import * as Yup from 'yup';

export const ContactSchema = Yup.object().shape({
	name: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('Name is required'),
	number: Yup.string().required('Phone number is required'),
	email: Yup.string().email('Please Enter a valid email address   ').required('Email is required'),
	message: Yup.string().required('Message is required').min(10, 'Message is too short - should be 10 chars minimum').max(500, 'Exceeded Chars Limit')
});
